import { useDispatch } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiResponse } from "types/api";

import { transformDraftToVariantVersion } from "./transformers";
import { TiVoAppVariantDraft } from "./types";

export const useVariantVersionDraft = (id?: string, variantId?: string) => {
  const dispatch = useDispatch();

  return useQuery({
    queryKey: ["variantVersionDraft", id, variantId],
    queryFn: (): ApiResponse<TiVoAppVariantDraft> =>
      dispatch(
        apiThatThrows.getTiVoVariantVersionDraft.action({
          params: { id, variantId },
        })
      ),
    enabled: Boolean(id && variantId), // don't run if no id
    select: (results) => ({
      meta: results.meta,
      results: transformDraftToVariantVersion(results.results),
    }),
  });
};
